import { useCryptoStore } from "@/store/crypto"
import { useAuthCrypto } from "./use-auth-crypto"

/** true while private mode is on and the key is not in memory (the veil is up). */
export function useVeiled(): boolean {
  const { data } = useAuthCrypto()
  const isUnlocked = useCryptoStore((s: { isUnlocked: boolean }) => s.isUnlocked)
  return data?.encryptionMode === "private" && !isUnlocked
}

/**
 * true while user data must NOT be fetched or rendered outside the route:
 * the veil is up, OR the encryption mode isn't known yet (it could turn out
 * to be private). Gate every shell-level query / stream / overlay on this —
 * the alerts stream and bell, the command palette, the quick-add composer.
 */
export function useDataLocked(): boolean {
  const { data } = useAuthCrypto()
  const isUnlocked = useCryptoStore((s: { isUnlocked: boolean }) => s.isUnlocked)
  if (!data) return true
  return data.encryptionMode === "private" && !isUnlocked
}
